import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteMeal } from "../store/mealsSlice"; // ← confirm action name
import { DeleteConfirmDialog } from "./utils/DeleteConfirmDialog";
import { IconTrash } from "@tabler/icons-react";


import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Select,
  Row, 
  Grid
} from "./layout";


import { selectAllMeals } from "../store/selectors";
import { selectAllFoods } from "../store/selectors";
import MealFormModal from "./forms/MealFormModal";

import defaultImage from "../assets/images/default-image.jpg";
import FoodImage from "./utils/FoodImage";

export default function MealOverviewGrid({ onSelectMeal }) {
  const dispatch = useDispatch();

  const meals = useSelector(selectAllMeals);
  const foods = useSelector(selectAllFoods);
  const [mealType, setMealType] = useState("all");
  const [search, setSearch] = useState("");
  const foodsById = useSelector(state => state.foods.byId);


  const [modalMeal, setModalMeal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  // const filteredMeals = meals.filter(meal => {
  //   const text = search.toLowerCase();

  //   const matchMealName =
  //     meal.name.toLowerCase().includes(text);

  //   const matchFoodName = Object.keys(meal.foodPortions || {}).some(id => {
  //       const food = foodsById[id];
  //       return food?.name.toLowerCase().includes(text);
  //     });

  //     return matchMealName || matchFoodName;
  // });

  const filteredMeals = meals.filter(meal => {
    const text = search.toLowerCase();

    const matchSearch =
      meal.name.toLowerCase().includes(text) ||
      Object.keys(meal.foodPortions || {}).some(id => {
        const food = foodsById[id];
        return food?.name.toLowerCase().includes(text);
      });

    const matchType =
      mealType === "all" ||
      meal.mealType === mealType;

    return matchSearch && matchType;
  });


  const handleEditMeal = (meal) => {
    setModalMeal(meal);
    setModalOpen(true);
  };

  const handleAddMeal = () => {
    setModalMeal(null);
    setModalOpen(true);
  };

  const handleClickMeal = (meal) => {
  if (onSelectMeal) {
    onSelectMeal(meal);   // 🔥 send back to Today screen
    return;
  }

  // normal library mode
  setModalMeal(meal);
  setModalOpen(true);
};


  if (!meals?.length) return <Text>No meals yet</Text>;

  return (
    <>
      <Screen>
        <Content>
          <TextInput
            placeholder="Search meal..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{marginBottom:space.md}}
          />
          {/* <Select
            value={mealType}
            onChange={(e) => setMealType(e.target.value)}
            style={{marginBottom:space.md}}
          >
            <MenuItem value="all">All meals</MenuItem>
            <MenuItem value="breakfast">Breakfast</MenuItem>
            <MenuItem value="lunch">Lunch</MenuItem>
            <MenuItem value="dinner">Dinner</MenuItem>
            <MenuItem value="snack">Snack</MenuItem>
          </Select> */}

              <Select
                value={mealType}
                placeholder="All categories"
                options={[
                  { label: "All meals", value: "all" },
                  { label: "Breakfast", value: "breakfast" },
                  { label: "Lunch", value: "lunch" },
                  { label: "Dinner", value: "dinner" },
                  { label: "Snack", value: "snack" },
                ]}
                onChange={setMealType}
                style={{marginBottom:space.md}}
              />

          <Button
            onClick={handleAddMeal}
            style={{marginBottom:space.md}}
          >
            Create new Meal
          </Button>

          <Grid
            gap= "5px"
          >
          
            {filteredMeals.map((meal) => {
            // {meals.map((meal) => {

              const mealFoods = foods.filter(f =>
                Object.keys(meal.foodPortions || {}).includes(f.id)
              );

              return (
                <Card 
                  key={meal.id}
                  onClick={() => handleClickMeal(meal)}
                  style={{
                    width:"100px",
                    padding:"0px !important",
                    position: "relative"
                    
                  }}
                >
                {/* <img src={defaultImage} alt=""/>  */}


                {meal.imageKey ? (
                  <FoodImage imageKey={meal.imageKey} alt={meal.name} />
                ) : (
                  <img src={defaultImage} alt="" width={100} height={100} style={{ objectFit: "cover" }} />
                )}
                  <Text 
                    style={{
                      fontWeight:"regular", 
                      fontSize:"10px",
                      lineHeight:"1"
                    }}
                  >
                    <span style={{fontWeight:"bold"}}> {meal.name}</span> •  {meal.calories} kcal 
                    {/* {mealFoods.map(f => f.name + " " + f.calories + " | ")} */}
                  </Text>

                  <button
                  // onClick={(e) => {
                  //   e.stopPropagation();
                  //   dispatch(deleteMeal(meal.id));
                  // }}
                    onClick={(e) => {
                      e.stopPropagation();          // ← prevents card click
                      setPendingDeleteId(meal.id);
                    }}

                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    background: "rgba(0,0,0,0.4)",
                    border: "none",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                  }}
                >
                  <IconTrash size={14} color="white" />
                </button>

                {pendingDeleteId === meal.id && (
                  <DeleteConfirmDialog
                    entryName={meal.name}
                    onConfirm={() => {
                      dispatch(deleteMeal(meal.id));
                      setPendingDeleteId(null);
                    }}
                    onCancel={() => setPendingDeleteId(null)}
                  />
                )}
     
                </Card>
              );
            })}
          </Grid>

          <MealFormModal
            open={modalOpen}
            meal={modalMeal}
            onClose={() => setModalOpen(false)}
          />
        </Content>
      </Screen>

    </>
  );
}